import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AutocompleteCategories,
  AutocompleteFreesolo,
  Select,
} from '../../fields';
import FormButtons from '../../FormButtons';
import TextFieldNumber from '../../../../../components/TextFieldNumber';
import { Form, FormBox } from '../index.styles';
import { Overlay } from '../../Title/index.styles';
import { stationaryCombustion } from '../../../../Pages/Questionnaire/directEmission';
import { choices, units } from '../data';

export default function FuelForm({
  state,
  setState,
  id,
  active,
  setActive,
  setNewForm,
}: {
  state: stationaryCombustion[];
  setState: Function;
  id: number;
  active: undefined | number;
  setActive: Function;
  setNewForm: Function;
}) {
  const { t } = useTranslation();

  const [amount_per_period_error_state, set_amount_per_period_error_state] =
    useState(false);
  const [type_of_fuel_error_state, set_type_of_fuel_error_state] =
    useState(false);
  const [unit_error_state, set_unit_error_state] = useState(false);
  const [manual_factor_error_state, set_manual_factor_error_state] =
    useState(false);

  let amount_per_period_error = false;
  let type_of_fuel_error = false;
  let unit_error = false;
  let manual_factor_error = false;
  const amount_per_period_validation = (value: string) => {
    if (value === '') amount_per_period_error = true;
    return amount_per_period_error;
  };

  const type_of_fuel_validation = (value: string) => {
    if (value === '') type_of_fuel_error = true;
    return type_of_fuel_error;
  };
  const unit_validation = (value: string) => {
    if (value === '') unit_error = true;
    return unit_error;
  };
  const manual_factor_validation = (value: string) => {
    if (value === '') manual_factor_error = true;
    return manual_factor_error;
  };

  const setAmountPerPeriod = (value: string) => {
    amount_per_period_validation(value);
    set_amount_per_period_error_state(false);
    const newForms = [...state];
    let tempForm = newForms[id];

    tempForm = {
      name_of_equipement: tempForm.name_of_equipement,
      unit: tempForm.unit,
      manual_factor: tempForm.manual_factor,
      type_of_fuel: tempForm.type_of_fuel,
      amount_per_period: value,
      comment: tempForm.comment,
    };
    newForms[id] = tempForm;
    setState(newForms);
    if (value === '') {
      set_amount_per_period_error_state(true);
    }
  };

  const setNameOfEquipment = (value: string) => {
    const newForms = [...state];
    let tempForm = newForms[id];
    tempForm = {
      name_of_equipement: value,
      unit: tempForm.unit,
      manual_factor: tempForm.manual_factor,
      type_of_fuel: tempForm.type_of_fuel,
      amount_per_period: tempForm.amount_per_period,
      comment: tempForm.comment,
    };
    newForms[id] = tempForm;
    setState(newForms);
  };

  const setTypeOfFuel = (value: string) => {
    type_of_fuel_validation(value);
    set_type_of_fuel_error_state(false);
    const newForms = [...state];
    let tempForm = newForms[id];

    tempForm = {
      name_of_equipement: tempForm.name_of_equipement,
      unit: tempForm.unit,
      manual_factor: tempForm.manual_factor,
      type_of_fuel: value,
      amount_per_period: tempForm.amount_per_period,
      comment: tempForm.comment,
    };
    newForms[id] = tempForm;
    setState(newForms);
    if (value === '') {
      set_type_of_fuel_error_state(true);
    }
  };

  const setManualFactor = (value: string) => {
    manual_factor_validation(value);
    set_manual_factor_error_state(false);
    const newForms = [...state];
    let tempForm = newForms[id];
    tempForm = {
      name_of_equipement: tempForm.name_of_equipement,
      unit: tempForm.unit,
      manual_factor: value === '' ? null : value,
      type_of_fuel: tempForm.type_of_fuel,
      amount_per_period: tempForm.amount_per_period,
      comment: tempForm.comment,
    };
    newForms[id] = tempForm;
    setState(newForms);
    if (newForms[id].type_of_fuel === 'other.manual_factor' && value === '') {
      set_manual_factor_error_state(true);
    }
  };

  const setUnit = (value: string) => {
    unit_validation(value);
    set_unit_error_state(false);
    const newForms = [...state];
    let tempForm = newForms[id];
    tempForm = {
      name_of_equipement: tempForm.name_of_equipement,
      unit: value,
      manual_factor: tempForm.manual_factor,
      type_of_fuel: tempForm.type_of_fuel,
      amount_per_period: tempForm.amount_per_period,
      comment: tempForm.comment,
    };
    newForms[id] = tempForm;
    setState(newForms);
    if (value === '') set_unit_error_state(true);
  };

  const defineErrors = async () => {
    if (state[id].amount_per_period === '') {
      set_amount_per_period_error_state(true);
      amount_per_period_error = true;
    }

    if (state[id].type_of_fuel === '') {
      set_type_of_fuel_error_state(true);
      type_of_fuel_error = true;
    }

    if (state[id].unit === '') {
      set_unit_error_state(true);
      unit_error = true;
    }

    if (
      state[id].type_of_fuel === 'other.manual_factor' &&
      !state[id].manual_factor
    ) {
      set_manual_factor_error_state(true);
      manual_factor_error = true;
    }
  };

  const handleRemove = async () => {
    const tempState = [...state];
    tempState.splice(id, 1);
    setState(tempState);

    if (tempState.length === 0) {
      setState([
        {
          amount_per_period: '',
          comment: '',
          manual_factor: null,
          name_of_equipement: '',
          type_of_fuel: '',
          unit: '',
        },
      ]);

      set_manual_factor_error_state(false);
      manual_factor_error = false;

      set_unit_error_state(false);
      unit_error = false;

      set_type_of_fuel_error_state(false);
      type_of_fuel_error = false;

      set_amount_per_period_error_state(false);
      amount_per_period_error = false;
    }

    setActive(undefined);
  };

  return (
    <>
      {active === id && (
        <Overlay
          onClick={() =>
            defineErrors().then(() => {
              if (
                !amount_per_period_error &&
                !unit_error &&
                !type_of_fuel_error &&
                !manual_factor_error
              ) {
                setActive(undefined);
              }
            })
          }
        />
      )}
      <Form active={active === id}>
        <div onClick={() => setActive(id)}>
          <FormBox variant="100">
            <AutocompleteFreesolo
              active
              index={2}
              max={4}
              options={[]}
              error={false}
              label={t(
                'direct-emission.stationary-combustion.name_of_equipement'
              )}
              value={
                state[id].name_of_equipement === null
                  ? ''
                  : state[id].name_of_equipement
              }
              setValue={(e: string) => setNameOfEquipment(e)}
            />
          </FormBox>
          <FormBox variant="50">
            <AutocompleteCategories
              active
              index={1}
              max={12}
              // @ts-ignore
              options={choices}
              label={t(`direct-emission.stationary-combustion.type_of_fuel`)}
              error={type_of_fuel_error_state}
              value={state[id].type_of_fuel}
              setValue={(e: string) => setTypeOfFuel(e)}
            />
          </FormBox>

          <FormBox variant="50">
            <Select
              active
              index={6}
              max={4}
              options={units}
              label={t('direct-emission.stationary-combustion.unit')}
              error={unit_error_state}
              value={state[id].unit}
              setValue={(value: string) => setUnit(value)}
            />
          </FormBox>

          <FormBox variant="100">
            <TextFieldNumber
              label={t(
                'direct-emission.stationary-combustion.amount_per_period'
              )}
              active
              error={amount_per_period_error_state}
              index={1}
              value={
                state[id].amount_per_period === null
                  ? ''
                  : state[id].amount_per_period
              }
              setValue={(e: string) => setAmountPerPeriod(e)}
            />
          </FormBox>

          {state[id].type_of_fuel === 'other.manual_factor' && (
            <FormBox variant="100">
              <TextFieldNumber
                type="factor"
                label={t('direct-emission.stationary-combustion.manual_factor')}
                active
                error={manual_factor_error_state}
                index={3}
                // @ts-ignore
                value={
                  state[id].manual_factor === null
                    ? ''
                    : state[id].manual_factor
                }
                setValue={(e: string) => setManualFactor(e)}
              />
            </FormBox>
          )}
        </div>
        {active === id && (
          <FormButtons
            setTable={setNewForm}
            canCopy={
              state[id].amount_per_period !== '' &&
              state[id].unit !== '' &&
              state[id].type_of_fuel !== '' &&
              (state[id].type_of_fuel !== 'other.manual_factor' ||
                !!state[id].manual_factor)
            }
            setActive={setActive}
            state={state}
            setState={setState}
            id={id}
            onClickRemove={() => handleRemove()}
            variant="sold-products"
          />
        )}
      </Form>
    </>
  );
}
